import { AdInsideList } from 'components/UI/AdInsideList/AdInsideList';
import { TeaserGridSection } from 'components/UI/TeaserGridSection';
import type { WidgetTeaserStandardProps } from 'types/cms-teaser';
import { slugify } from 'utils/string';

export const WidgetTeaserStandard = ({
  context,
  isSponsored,
}: {
  context: WidgetTeaserStandardProps;
  isSponsored?: boolean;
}) => {
  const width = 735;
  const teaserOffset = context.trackingContext?.teaserOffset ?? 0;
  const sectionSlug = context.trackingContext?.sectionSlug ?? slugify(context.model?.fields?.title ?? 'standard');
  const itemCount = context?.items?.length ?? 0;

  return (
    <TeaserGridSection
      title={context.model?.fields?.title}
      titleLink={context.model?.fields?.link}
      isSponsored={isSponsored}
      anchor={context.model?.fields?.anchor}
      variant={itemCount <= 2 ? 'medium' : 'default'}
    >
      <AdInsideList
        context={context}
        teaserImageWidth={width}
        teaserOffset={teaserOffset}
        sectionSlug={sectionSlug}
        firstTeaserHighlight={context.model?.fields?.firstTeaserHighlight}
        disableLazyLoading={context.model?.fields?.disableLazyLoading}
      />
    </TeaserGridSection>
  );
};
